import { render } from "./dashboard-financial.vue?vue&type=template&id=a98ed798&scoped=true"
import script from "./dashboard-financial.vue?vue&type=script&lang=js"
export * from "./dashboard-financial.vue?vue&type=script&lang=js"

import "./dashboard-financial.vue?vue&type=style&index=0&id=a98ed798&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a98ed798"]])

export default __exports__